// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ProjectUserSchema = z.object({
  user_id: z.number().int(),
  hour_rate: z.number(),
  hour_rate_in_cents: z.number(),
  updated_at: z.string().datetime(),
  created_at: z.string().datetime(),
  deleted: z.boolean(),
  internal_hour_rate: z.number(),
  internal_hour_rate_in_cents: z.number(),
});
